<script lang="ts">
  import Router from 'svelte-spa-router';
  import { ProjectConfigService } from '../../modules';
  import Header from '../Header.svelte';
  import ProjectSidebar from '../project/ProjectSidebar.svelte';
  import ProjectReportList from '../project/ProjectReportList.svelte';
  import ProjectSourceList from '../project/ProjectSourceList.svelte';
  import ProjectSettings from '../project/ProjectSettings.svelte';
  import ProjectStats from '../project/ProjectStats.svelte';
  import ProjectEvents from '../project/ProjectEvents.svelte';
  import ProjectUserEvents from '../project/ProjectUserEvents.svelte';
  import ProjectDistinctIdEvents from '../project/ProjectDistinctIdEvents.svelte';
  import ProjectEventFeed from '../project/ProjectEventFeed.svelte';
  import ProjectFeaturedItems from '../project/ProjectFeaturedItems.svelte';
  import NotFound from './NotFound.svelte';
  import { createRoutesWithPrefix } from '../../router/router.helpers';

  export let params: { project: string };

  const projectConfig = ProjectConfigService.get(params.project);

  const routes = createRoutesWithPrefix('/project/:project', {
    '/reports': ProjectReportList,
    '/sources': ProjectSourceList,
    '/settings': ProjectSettings,
    '/stats': ProjectStats,
    '/featured-items/': ProjectFeaturedItems,
    '/events': ProjectEventFeed,
    '/user/:userId': ProjectUserEvents,
    '/users/distinct/:distinctId': ProjectDistinctIdEvents,
    '/users/:distinct?': ProjectEvents,
    '/*': NotFound,
  });
</script>

<Header title={projectConfig.name} titleLink="/project/{projectConfig.key}" />
<ProjectSidebar {projectConfig} />
<div class="page">
  <Router {routes} />
</div>
